import {baseQaConfig} from '../base/qa.config';
import {cnetDevConfig} from './dev.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cnetQaConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseQaConfig, cnetDevConfig, {
  environmentName: 'Cnet QA Environment',
  ionicEnvName: 'qa',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cnet/qa.config.ts